import { render, staticRenderFns } from "./DataDeletion.vue?vue&type=template&id=346b62bc&scoped=true"
import script from "./DataDeletion.vue?vue&type=script&lang=js"
export * from "./DataDeletion.vue?vue&type=script&lang=js"
import style0 from "./DataDeletion.vue?vue&type=style&index=0&id=346b62bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b62bc",
  null
  
)

export default component.exports